module.exports = __webpack_public_path__ + "static/media/fly0136.ddcaf099.webp";